export enum DocumentContainerType {
  ClientContainer = 1,
  HistoryContainer = 2,
}

export namespace DocumentContainerType {
  export const displayName = (documentContainerType: DocumentContainerType) => {
    switch (documentContainerType) {
      case DocumentContainerType.ClientContainer:
        return 'Document Request History';
      case DocumentContainerType.HistoryContainer:
        return 'Hospital Document Requests';
      default:
        return '';
    }
  };
}
